import React from 'react'
import {
    Box,
    Button,
    Card,
    CardContent,
    
} from '@material-ui/core'
import ViewListIcon from '@material-ui/icons/ViewList'
import ViewListOutlineIcon from '@material-ui/icons/ViewListOutlined'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
import ViewModuleOutlineIcon from '@material-ui/icons/ViewModuleOutlined'
// barcode scanner
import BarCodeScanner from '../barcode-scanner'


const ProductListToolbar = props => {
    const { viewC, setViewC } = props.prop
    const { innerWidth: windowWidth } = window
    const setIt = value => {
        setViewC(value)
        localStorage.setItem('view_c', value ? 1 : 0)
    }
    return (
        <>
        <Box {...props}>
                <Box sx={{ mb: 2 }}>
                    {windowWidth <= 425 && (
                        <Box sx={{  textAlign:'center'}}>
                            <BarCodeScanner />
                        </Box>
                    )}
                    {windowWidth > 425 && (
                        <Card  className='header-card'>
                        <CardContent sx={{ justifyContent: 'center'}}>
                                <Box sx={{ float: 'left' }}>
                                    <BarCodeScanner />
                                </Box>
                                <Box sx={{ float: 'right' }}>
                                    <Button onClick={() => setIt(true)}>
                                        {viewC ? (
                                            <ViewModuleIcon fontSize='large' />
                                        ) : (
                                            <ViewModuleOutlineIcon color='disabled' fontSize='large' />
                                        )}
                                    </Button>
                                    <Button onClick={() => setIt(false)}>
                                        {viewC ? (
                                            <ViewListOutlineIcon color='disabled' fontSize='large' />
                                        ) : (
                                            <ViewListIcon fontSize='large' />
                                        )}
                                    </Button></Box>
                        </CardContent>
                        </Card>
                    )}
                    </Box>
            </Box>
            </>
    )
}

export default ProductListToolbar
